import { useCallback, useEffect, useState } from 'react';
import './LogViewer.css';
import { authFetch } from '../auth';

const API_BASE = '/api';
const PREVIEW_LEN = 50;

const preview = (s) => {
  if (!s) return '';
  return s.length > PREVIEW_LEN ? s.slice(0, PREVIEW_LEN) + '…' : s;
};
const fmt = (iso) => (iso ? String(iso).replace('T', ' ').slice(0, 19) : '');

/** 홈페이지 문의하기(ContactForm) 접수 내역 조회 (읽기 전용). */
export default function InquiryLogs() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [detail, setDetail] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await authFetch(`${API_BASE}/inquiries`);
      if (!res.ok) throw new Error(`문의 조회 실패 (${res.status})`);
      const data = await res.json();
      // 최신 접수가 위로
      data.sort((a, b) => (b.id || 0) - (a.id || 0));
      setItems(data);
    } catch (e) {
      setError(`${e.message} — 백엔드(8080)가 실행 중인지 확인하세요.`);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="logv">
      <div className="logv-head">
        <div>
          <h1 className="logv-title">문의하기 접수</h1>
          <p className="logv-sub">홈페이지 문의 폼으로 접수된 내역 ({items.length}건)</p>
        </div>
        <button type="button" className="logv-refresh" onClick={load}>새로고침</button>
      </div>

      {error && <div className="logv-error">{error}</div>}

      <div className="logv-card">
        <table className="logv-table">
          <thead>
            <tr>
              <th style={{ width: 160 }}>접수 시각</th>
              <th style={{ width: 120 }}>성명</th>
              <th style={{ width: 150 }}>휴대폰</th>
              <th style={{ width: 200 }}>이메일</th>
              <th>문의 내용</th>
              <th style={{ width: 80 }}>상세</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={6} className="logv-empty">불러오는 중…</td></tr>
            ) : items.length === 0 ? (
              <tr><td colSpan={6} className="logv-empty">접수된 문의가 없습니다.</td></tr>
            ) : (
              items.map((it) => (
                <tr key={it.id}>
                  <td className="logv-date">{fmt(it.createdAt)}</td>
                  <td>{it.name}</td>
                  <td>{it.phone || '-'}</td>
                  <td>{it.email}</td>
                  <td className="logv-detail">{preview(it.message)}</td>
                  <td><button type="button" className="logv-more" onClick={() => setDetail(it)}>자세히</button></td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {detail && (
        <div className="logv-modal-overlay" onMouseDown={() => setDetail(null)}>
          <div className="logv-modal" onMouseDown={(e) => e.stopPropagation()}>
            <h2 className="logv-modal-title">문의 상세</h2>
            <dl className="logv-meta">
              <div><dt>접수 시각</dt><dd>{fmt(detail.createdAt)}</dd></div>
              <div><dt>성명</dt><dd>{detail.name}</dd></div>
              <div><dt>휴대폰</dt><dd>{detail.phone || '-'}</dd></div>
              <div><dt>이메일</dt><dd>{detail.email}</dd></div>
              <div><dt>개인정보 동의</dt><dd>{detail.privacyConsent ? '동의' : '미동의'}</dd></div>
            </dl>
            <div className="logv-detail-label">문의 내용</div>
            <div className="logv-detail-full">{detail.message || '(내용 없음)'}</div>
            <div className="logv-modal-actions">
              <button type="button" className="logv-modal-close" onClick={() => setDetail(null)}>닫기</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
